import { generateGetEndpoint, generatePostEndpoint } from "src/api/@utils";

const baseURL = "/scrapper-alerted-users";

export const useScraperAlertEndpoints = () => {
    const fetchAll = generateGetEndpoint<Array<any>>(baseURL);
    const add = generatePostEndpoint<{email: string}, any>(baseURL);
    
    // Модифицировано под POST:
    const remove = generatePostEndpoint<{id: string}, {deletedId: string}>(baseURL + "/delete");

    return {
        fetchAll,
        add,
        remove
    };
};

export { baseURL };